import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { DropdownModule } from 'primeng/dropdown';
import { SaidaEstoqueInserirIdentificadaComponent } from './saida-estoque-inserir-identificada.component';
import { SaidaEstoqueInserirIdentificadaRoutingModule } from './saida-estoque-inserir-identificada-routing.module';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    SaidaEstoqueInserirIdentificadaComponent
  ],
  imports: [
    CommonModule,
    SaidaEstoqueInserirIdentificadaRoutingModule,
    FormsModule,
    TableModule,
    DialogModule,
    ProgressSpinnerModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    DividerModule,
    MessagesModule,
    CalendarModule,
    TooltipModule,
    DropdownModule,
    FormatPipeModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class SaidaEstoqueInserirIdentificadaModule { }
